import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';
import { Grid, GridColumn as Column, GridCell } from '@progress/kendo-react-grid';
import { DatePicker, TimePicker, DatePickerChangeEvent, TimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    childId: string;
}>;

type State = {
    attendances: Attendance[];
    data: Attendance[];
    childId: number;
    isLoading: boolean;
}

type Attendance = {
    ChildId: number;
    ChildScheduleID: number;
    CheckInTime: DateTimeValue | null;
    CheckOutTime: DateTimeValue | null;
    FacilityIANA: string;
    CheckInTimeInEdit: Boolean | undefined;
    CheckOutTimeInEdit: Boolean | undefined;
    InEdit: Boolean | undefined;
}

export type DateTimeValue = {
    DateTime: Date;
    IANA: string;
}

export default class ChildAttendances extends React.Component<Props, State> {

    CheckInCell: typeof GridCell
    CheckOutCell: typeof GridCell
    EditCell: typeof GridCell

    constructor(props: Props) {
        super(props);

        this.state = {
            attendances: [],
            data: [],
            childId: 0,
            isLoading: true,
        }

        this.itemChange = this.itemChange.bind(this);
        const enterEdit = this.enterEdit.bind(this);
        const save = this.save.bind(this);
        const cancel = this.cancel.bind(this);
        const remove = this.remove.bind(this);
        const CheckInFunc = this.CheckInFunc.bind(this);
        const CheckOutFunc = this.CheckOutFunc.bind(this);

        class CheckIn extends GridCell {
            render() {
                if (!this.props.dataItem.InEdit && this.props.dataItem.CheckInTime) {
                    return (
                        <td>{moment.utc(this.props.dataItem.CheckInTime.DateTime).tz(this.props.dataItem.CheckInTime.IANA).format("MM/DD/YYYY hh:mm A z")}</td>
                    );
                } else if (this.props.dataItem.CheckInTimeInEdit || this.props.dataItem.CheckInTime) {
                    if (!this.props.dataItem.CheckInTime)
                        this.props.dataItem.CheckInTime = { DateTime: moment().toDate(), IANA: this.props.dataItem.FacilityIANA } as DateTimeValue;
                    return (
                        <td >
                            <div>
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    max={moment().toDate()}
                                    name="CheckInDate"
                                    formatPlaceholder="formatPattern"
                                    value={moment.utc(this.props.dataItem.CheckInTime.DateTime).tz(this.props.dataItem.CheckInTime.IANA).toDate()}
                                    onChange={this.handleChange.bind(this)}
                                />&nbsp;
                            <TimePicker
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    value={moment.utc(this.props.dataItem.CheckInTime.DateTime).tz(this.props.dataItem.CheckInTime.IANA).toDate()}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </div>
                        </td>
                    )
                } else
                    return (<td><button role="button" className="btn btn-primary" onClick={() => CheckInFunc(this.props.dataItem)}>Check-In</button></td>);
            }

            private handleChange(e: DatePickerChangeEvent|TimePickerChangeEvent) {
                if (this.props.onChange) {
                    this.props.onChange({
                        dataItem: this.props.dataItem,
                        field: this.props.field,
                        syntheticEvent: e.syntheticEvent,
                        value: e.target.value
                    });
                }
            }
        }

        class CheckOut extends GridCell {
            render() {
                if (!this.props.dataItem.InEdit && this.props.dataItem.CheckOutTime) {
                    return (
                        <td>{moment.utc(this.props.dataItem.CheckOutTime.DateTime).tz(this.props.dataItem.CheckOutTime.IANA).format("MM/DD/YYYY hh:mm A z")}</td>
                    );
                } else if (this.props.dataItem.CheckOutTimeInEdit || this.props.dataItem.CheckOutTime) {
                    if (!this.props.dataItem.CheckOutTime)
                        this.props.dataItem.CheckOutTime = { DateTime: moment().toDate(), IANA: this.props.dataItem.FacilityIANA } as DateTimeValue;
                    return (
                        <td >
                            <div>
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    max={moment().toDate()}
                                    name="CheckInDate"
                                    formatPlaceholder="formatPattern"
                                    value={moment.utc(this.props.dataItem.CheckOutTime.DateTime).tz(this.props.dataItem.CheckOutTime.IANA).toDate()}
                                    onChange={this.handleChange.bind(this)}
                                />&nbsp;
                            <TimePicker
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    value={moment.utc(this.props.dataItem.CheckOutTime.DateTime).tz(this.props.dataItem.CheckOutTime.IANA).toDate()}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </div>
                        </td>
                    )
                } else
                    return (<td><button role="button" className="btn btn-primary" disabled={!this.props.dataItem.CheckInTime} onClick={() => CheckOutFunc(this.props.dataItem)}>Check-Out</button></td>);
            }

            private handleChange(e: DatePickerChangeEvent|TimePickerChangeEvent) {
                if (this.props.onChange) {
                    this.props.onChange({
                        dataItem: this.props.dataItem,
                        field: this.props.field,
                        syntheticEvent: e.syntheticEvent,
                        value: e.target.value
                    });
                }
            }
        }

        class Edit extends GridCell {
            public render() {
                return !this.props.dataItem.InEdit ?
                    (<td>
                        <button
                            className="k-primary k-button k-grid-edit-command"
                            onClick={() => enterEdit(this.props.dataItem)}
                        >Edit</button>
                        <button
                            className="k-button k-grid-remove-command"
                            onClick={() => confirm('Delete?') &&
                                remove(this.props.dataItem)}
                        >Remove</button>
                    </td>
                    ) : (
                        <td>
                            <button
                                className="k-button k-grid-save-command"
                                onClick={() => save(this.props.dataItem)}
                            >Update</button>
                            <button
                                className="k-button k-grid-cancel-command"
                                onClick={() => cancel(this.props.dataItem)}
                            >Cancel</button>
                        </td>
                    );
            }
        }

        this.CheckInCell = CheckIn;
        this.CheckOutCell = CheckOut;
        this.EditCell = Edit;
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.getAttendances(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.attendances && this.state.childId != childId) {
            this.getAttendances(childId);
        }
    }

    public render() {
        return <div>
            <br />
            <DocumentTitle title="Attendance" />
            <h1>Attendance</h1>
            <br />
            <Grid data={this.state.data}
                onItemChange={this.itemChange}
                editField="InEdit"
            >
                <Column field="CheckInTime" title="Check-in time" cell={this.CheckInCell} filter="date" />
                <Column field="CheckOutTime" title="Check-out time" cell={this.CheckOutCell} filter="date" />
                <Column field="Edit" title="Edit" cell={this.EditCell} editable={false} />
            </Grid>
            <br />
        </div>
    }

    private enterEdit(dataItem: Attendance) {
        this.update(this.state.data, dataItem).then((data) => {
            data.InEdit = true;
            this.setState({ data: this.state.data.slice() });
        });
    }

    private save(dataItem: Attendance) {
        dataItem.InEdit = undefined;

        this.update(this.state.attendances, dataItem).then((data) => {

            if (dataItem.ChildScheduleID) {
                //dataItem.CheckInTime = moment(dataItem.CheckInTime as Date).utc().toDate();
                //dataItem.CheckOutTime = moment(dataItem.CheckOutTime as Date).utc().toDate();
                fetchApi(`api/Attendance/Save/${dataItem.ChildScheduleID}`, dataItem, 'POST');
            }

            dataItem.ChildScheduleID = data.ChildScheduleID;

            this.setState({
                data: this.state.data.slice()
            });
        });
    }

    private getAttendances(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/Attendance/List/${childId}`)
            .then((attendances: Attendance[]) => {
                //attendances.map((attendance, index) => {
                //   // console.log(attendances[index].CheckInTime);
                //    attendances[index].CheckInTime = moment.utc(attendance.CheckInTime as Date).local().toDate();
                //    if (attendances[index].CheckOutTime != null) {
                //        attendances[index].CheckOutTime = moment.utc(attendance.CheckOutTime as Date).local().toDate();
                //    }
                //    //console.log(attendances[index].CheckInTime);
                //    //console.log("");
                //});
                this.setState({ isLoading: false, attendances: JSON.parse(JSON.stringify(attendances)), data: attendances }, () => {
                });
            });
    }

    private cancel(dataItem: Attendance) {
        dataItem.InEdit = false;
        dataItem.CheckInTimeInEdit = false;
        dataItem.CheckOutTimeInEdit = false;
        if (dataItem.ChildScheduleID) {
            let originalItem = this.state.attendances.find(p => p.ChildScheduleID === dataItem.ChildScheduleID);
            this.update(this.state.data, originalItem as Attendance);
        } else {
            this.update(this.state.data, dataItem, !dataItem.ChildScheduleID);
        }
        this.setState({ data: this.state.data.slice() });
    }

    private remove(dataItem: Attendance) {
        dataItem.InEdit = undefined;
        this.update(this.state.data, dataItem, true);
        this.update(this.state.attendances, dataItem, true);
        this.setState({ data: this.state.data.slice() });
        if (dataItem.ChildScheduleID) {
            fetchApi(`api/Attendance/Delete/${dataItem.ChildScheduleID}`, {}, 'DELETE');
        }
    }

    private itemChange(event: any) {
        const value = event.value;
        const name = event.field;

        if (!name) {
            return;
        }

        console.log(name + " " + value);

        const updatedData = this.state.data.slice();
        this.update(updatedData, event.dataItem).then((item) => {
            switch (name) {
                case "CheckInTime":
                case "CheckOutTime":
                    ((item as any)[name] as DateTimeValue).DateTime = value;
                    break;
                default:
                    (item as any)[name] = value;
                    break;
            }
            this.setState({ data: updatedData });
        });
    }

    private async update(data: Attendance[], item: Attendance, remove: boolean = false): Promise<Attendance> {
        let updated;
        let index = data.findIndex((p) => p === item || item.ChildScheduleID !== 0 && p.ChildScheduleID === item.ChildScheduleID);
        if (index >= 0) {
            updated = Object.assign({}, item)
            data[index] = updated;
        }

        if (remove)
            data = data.splice(index, 1);

        return data[index];
    }

    private CheckInFunc(dataItem: Attendance) {
        dataItem.CheckInTimeInEdit = true;
        this.enterEdit(dataItem);
    }

    private CheckOutFunc(dataItem: Attendance) {
        console.log("CheckOutTimeInEdit0");
        dataItem.CheckOutTimeInEdit = true;
        console.log("CheckOutTimeInEdit1");
        this.enterEdit(dataItem);
        console.log("CheckOutTimeInEdit2");
    }
}
